import { RouteConstants } from "routes/RouteConstants";

export const redirection_url =
  process.env.REACT_APP_ACCOUNT_SITE_URL + RouteConstants.confirmLink;
// process.env.REACT_APP_ACCOUNT_SITE_URL + RouteConstants.confirmLink;

export const reset_password_redirection_url =
  process.env.REACT_APP_ACCOUNT_SITE_URL + RouteConstants.resetPassword;
// process.env.REACT_APP_ACCOUNT_SITE_URL + RouteConstants.resetPassword;

export const ministryLevel = {
  1: "Youth Ministry",
  2: "Kids Ministry",
  3: "I Oversee Both",
  4: "None of These",
};

export const config_name = {
  // account: 1,
  // curriculum: 2,
  // builder: 3,
  // game: 4,
  // hub: 5,
  // slider: 6,
  // people: 7,
  // affiliate: 8,
  "free-trial-groups": 9,
  // habit: 10,
  "free-trial-students": 11,
  "free-trial-kids": 12,
  // admin: 13,
  // "grow-you": 14,
  // tv: 15,
  "free-vbs": 16,
};
